import Vue from 'vue'
import Router from 'vue-router'
import api from './fetch/api'

import login from './views/Login.vue'

Vue.use(Router);

//
let routes = [
    {
        path: '/login',
        component: login,
        name: '',
        hidden: true
    },
    
];
const router = new Router({
    mode: 'history',
    routes
    /*: [
        { path: '*', component: notFound }
    ]*/
});

// import MenuUtils from '@/scripts/common/MenuUtils'
import axios from 'axios'


router.beforeEach((to, from, next) => {
   /* var explorer = window.navigator.userAgent.toLowerCase() ;
    //ie
    if (explorer.indexOf("msie") >= 0) {
        let ver = explorer.match(/msie ([\d.]+)/)[1];
        let hint = '您的ie浏览器当前版本过低，请升级到ie10及以上'
        if(ver < 10){
            alert(hint);
        }
        return false;
    }*/

    if (to.path == '/') {
        window.location.href = '/login';
        return false;
    }
    if (to.path == '/login') {
        sessionStorage.clear();
        next()
        return false;
    }
    if (to.path === '/login') {
        //这里不使用router进行跳转，是因为，跳转到登录页面的时候，是需要重新登录，获取数据的，这个时候，会再次向router实例里面add路由规则，
        //而next()跳转过去之后，没有刷新页面，之前的规则还是存在的，但是使用location的话，可以刷新页面，当刷新页面的时候，整个app会重新加载
        //而我们在刷新之前已经把sessionStorage里的user移除了，所以上面的添加路由也不行执行
        window.sessionStorage.removeItem('menuInfo');
        window.sessionStorage.removeItem('isLoadNodes');
        window.location.href = '/login';
        return false;
    }
    if (to.path != '/login') {
        window.location.href = '/login';
    } else {
        if (to.path) {
            // axios.get('../static/version.json?_=' + Math.random()).then(response => {
            //     if (200 == response.status) {
            //         if (typeof (response.data.version)!='undefined'&&process.env.VERSION !== response.data.version) {
            //             window.location.reload(true);
            //             return;
            //         }
            //         next();
            //     }
            // }).catch(err => {
            //     next();
            // });
            next();
            if(to.path=='/main'){
                history.pushState(null, null, document.URL);
            }
        } else {
            next({path: '/404'})
        }
    }
});
router.afterEach((to, from, next) => {
    document.title = '云半径';
});
export default router;


// WEBPACK FOOTER //
// ./src/routes.js